<template>
  <div class="staff-management-settings-container">
    <div class="title-table-staff-setting h2-text">Staff Management</div>
    <div class="global-rate-of-pay-table">
      <GlobalRateOfPay :staffSettings="staffSettings"></GlobalRateOfPay>
    </div>
<!--    <EditMileageRateModal :staffConfig="staffSettings"></EditMileageRateModal>-->
  </div>
</template>
<script>
  import GlobalRateOfPay from './GlobalRateOfPay';
  import EditMileageRateModal from '../modal/globalSettings/EditMileageRateModal';

  export default {
    name: 'c-staff-management-settings',
    components: {
      GlobalRateOfPay,
      EditMileageRateModal
    },
    props: {
      staffSettings: {
        type: Object,
        required: true
      }
    },
    computed: {
    },
    methods: {
    }
  };
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// StaffManagement.vue?062681ba